import React from "react";

interface SeoProps {
  title: string;
  description: string;
  keywords?: string;
  image?: string;
  url?: string;
}

export const SeoComponent: React.FC<SeoProps> = ({
  title,
  description,
  keywords = "volumetric, labs, blockchain, ai, cloud, software, development",
  image = "https://file.volumetric.dev/volumetric-banner.jpg",
  url = "https://volumetric.dev",
}) => {
  const siteTitle = "Volumetric Labs";
  const fullTitle = title === siteTitle ? title : `${title} | ${siteTitle}`;

  // Determine Twitter card type based on image
  // If it's the square logo (volumetric360), use 'summary' to avoid stretching
  // Otherwise default to 'summary_large_image' for the banner and other feature images
  const twitterCard = image.includes("volumetric360")
    ? "summary"
    : "summary_large_image";

  return (
    <>
      {/* Standard metadata */}
      <title>{fullTitle}</title>
      <meta name="description" content={description} />
      <meta name="keywords" content={keywords} />

      {/* Open Graph / Facebook */}
      <meta property="og:type" content="website" />
      <meta property="og:url" content={url} />
      <meta property="og:title" content={fullTitle} />
      <meta property="og:description" content={description} />
      <meta property="og:image" content={image} />

      {/* Twitter */}
      <meta property="twitter:card" content={twitterCard} />
      <meta property="twitter:site" content="@volumetric" />
      <meta property="twitter:creator" content="@volumetric" />
      <meta property="twitter:url" content={url} />
      <meta property="twitter:title" content={fullTitle} />
      <meta property="twitter:description" content={description} />
      <meta property="twitter:image" content={image} />

      {/* Canonical */}
      <link rel="canonical" href={url} />
    </>
  );
};
